<template>
  <Modal
    v-model:visible="isVisible"
    class="spot-market-error-modal"
    :header="t('carrierPortal.spotMarket.spotMarketRequestError')"
    dismissable-mask
    @keypress.esc="isVisible = false"
  >
    <p>{{ t('carrierPortal.spotMarket.requestErrors', numErrors) }}</p>

    <div
      v-for="spotMarket in spotMarkets"
      :key="spotMarket.carrier!.id"
      class="flex flex-column flex-gap-1"
    >
      <ul class="spot-market-error-list">
        <li v-for="error in spotMarket.errors" :key="error">
          <SpotMarketMissingEmailError
            v-if="error === SpotMarketExceptionReason.MISSING_EMAIL"
            :carrier="spotMarket.carrier"
          />
        </li>
      </ul>
    </div>

    <template #footer>
      <RygenButton
        mode="tertiary"
        :label="t('common.confirm')"
        @click="isVisible = false"
      />
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { SpotMarket, SpotMarketExceptionReason } from '@/model';

import SpotMarketMissingEmailError from '@/components/carrierPortal/SpotMarketMissingEmailError.vue';
import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';
import Modal from '@rygen/rygen-ui/components/ui/Modal.vue';

const isVisible = defineModel('visible', {
  type: Boolean,
  default: () => false,
});

const props = defineProps({
  spotMarkets: {
    type: Array as PropType<SpotMarket[]>,
    default: () => [],
  },
});
const { spotMarkets } = toRefs(props);

const { t } = useI18n();

const numErrors = computed(() => {
  return spotMarkets.value.reduce(
    (total, spotMarket) => total + spotMarket.errors.length,
    0,
  );
});
</script>

<style>
.spot-market-error-modal {
  p:first-of-type {
    margin-bottom: var(--sp-6);
  }

  .spot-market-error-list {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}
</style>
